import TeamInvitation from './TeamInvitation';

export default TeamInvitation;
